import React from 'react'
import { useLocation, matchPath } from 'react-router-dom'

import { SidebarItemsType } from '../../types/sidebar'
import SidebarNavListItem from './SidebarNavListItem'

type SidebarNavListProps = {
  depth: number
  pages: SidebarItemsType[]
}

const SidebarNavList: React.FC<SidebarNavListProps> = ({ pages, depth }) => {
  const { pathname } = useLocation()

  return (
    <>
      {pages.map((page) => {
        const open = page.href
          ? !!matchPath(
              {
                path: page.href,
                end: false
              },
              pathname
            )
          : false

        if (page.children) {
          return (
            <SidebarNavListItem
              depth={depth}
              icon={page.icon}
              key={page.title}
              badge={page.badge}
              open={open}
              title={page.title}
              href={page.href}
            >
              <SidebarNavList depth={depth + 1} pages={page.children} />
            </SidebarNavListItem>
          )
        }

        return (
          <SidebarNavListItem
            depth={depth}
            href={page.href}
            icon={page.icon}
            key={page.title}
            badge={page.badge}
            title={page.title}
          />
        )
      })}
    </>
  )
}

export default SidebarNavList
